import InterestsSelector from "@/components/shared/InterestsSelector";
import { useState } from "react";
import OnboardingLayout from "./OnboardingLayout";

interface InterestsStepProps {
  onContinue: (interests: string[]) => void;
  initialValue: string[];
}

export default function InterestsStep({ onContinue, initialValue }: InterestsStepProps) {
  const [selectedInterests, setSelectedInterests] = useState<string[]>(initialValue);
  const MIN_INTERESTS = 5;

  return (
    <OnboardingLayout
      title="Choose your interests"
      onContinue={() => onContinue(selectedInterests)}
      canContinue={selectedInterests.length >= MIN_INTERESTS}
      step={4}
      totalSteps={5}
      buttonText={
        selectedInterests.length >= MIN_INTERESTS ? "Continue" : `${selectedInterests.length}/${MIN_INTERESTS} selected`
      }
    >
      <div className="max-h-[60vh] overflow-y-auto pr-2">
        <InterestsSelector
          selectedInterests={selectedInterests}
          onChange={setSelectedInterests}
          minRequired={MIN_INTERESTS}
        />
      </div>
    </OnboardingLayout>
  );
}
